export const toggleDrawer = ()=>{
  return dispatch => {
    dispatch({ type: "TOGGLE_DRAWER" });
  };
}

export const activateSection = (el)=>{
  return dispatch=>{
    dispatch({
      type:"ACTIVATE_SECTION",
      payload:el
    })
  }
}


// WEBPACK FOOTER //
// ./src/containers/application/redux_actions.js